module.exports = __webpack_public_path__ + "static/media/freightspeed.2d645ca0.png";